//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Example socialItem prop
 * {
 *  "label": "Facebook",
 *  "url": "https://facebook.com/cicada-idnr",
 * }
 */
export default {
  props: {
    socialItem: {
      type: Object,
      default: () => ({}),
    },
  },
};
